import { setCookie } from "@/lib/setCookie";
import { RootState } from "@/redux/store";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useHeader = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState<boolean>(false);
  const [isRoleMenuOpen, setIsRoleMenuOpen] = useState<boolean>(false);
  const [isLogoutOpen, setIsLogoutOpen] = useState<boolean>(false);

  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  const handleClose = () => setIsOpen(false);

  const onLogoutClick = () => {
    setIsLogoutOpen(true);
  };

  const onLogout = () => {
    // dispatch(reset());
    // queryClient.clear();
    setCookie("accessToken", "");
    navigate(`/`);
  };

  return {
    isOpen,
    onLogoutClick,
    handleClose,
    setIsOpen,
    isLogoutOpen,
    setIsLogoutOpen,
    onLogout,
    isProfileMenuOpen,
    setIsProfileMenuOpen,
    isRoleMenuOpen,
    setIsRoleMenuOpen,
    loggedInUserData,
  };
};

export default useHeader;
